module.exports = __webpack_public_path__ + "imgs/vape.7d8c9382182063961c46b8bfccb01291.jpg";